<ng-container *transloco="let t">
  <div
    [class.black]="loadingState$$().screenColor === 'black'"
    [class.white]="loadingState$$().screenColor === 'white'"
    class="backdrop"
  >
    <div aria-live="polite" class="loading-content" role="status">
      <ess-loading-spinner [color]="loadingState$$().screenColor" />
      <p class="sans">
        {{ t(loadingState$$().messageKey) }}
        <span>{{ t('itinerary.thisRequestCouldTakeAFewSeconds') }} </span>
      </p>
    </div>
  </div>
</ng-container>
